import { render, staticRenderFns } from "./image-element.vue?vue&type=template&id=588fc76a&scoped=true&"
import script from "./image-element.vue?vue&type=script&lang=js&"
export * from "./image-element.vue?vue&type=script&lang=js&"
import style0 from "./image-element.vue?vue&type=style&index=0&id=588fc76a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fc76a",
  null
  
)

export default component.exports